module.exports = new __parcel__URL__("GenericError.42a632b0.svg").toString();